import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteOrderFulfillmentPicturesMutationVariables = Types.Exact<{
  picture_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type DeleteOrderFulfillmentPicturesMutation = { __typename?: 'Mutation', deleteOrderFulfillmentPictures: boolean };


export const DeleteOrderFulfillmentPicturesDocument = gql`
    mutation DeleteOrderFulfillmentPictures($picture_ids: [ID!]!) {
  deleteOrderFulfillmentPictures(picture_ids: $picture_ids)
}
    `;
export type DeleteOrderFulfillmentPicturesMutationFn = Apollo.MutationFunction<DeleteOrderFulfillmentPicturesMutation, DeleteOrderFulfillmentPicturesMutationVariables>;

/**
 * __useDeleteOrderFulfillmentPicturesMutation__
 *
 * To run a mutation, you first call `useDeleteOrderFulfillmentPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderFulfillmentPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderFulfillmentPicturesMutation, { data, loading, error }] = useDeleteOrderFulfillmentPicturesMutation({
 *   variables: {
 *      picture_ids: // value for 'picture_ids'
 *   },
 * });
 */
export function useDeleteOrderFulfillmentPicturesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderFulfillmentPicturesMutation, DeleteOrderFulfillmentPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderFulfillmentPicturesMutation, DeleteOrderFulfillmentPicturesMutationVariables>(DeleteOrderFulfillmentPicturesDocument, options);
      }
export type DeleteOrderFulfillmentPicturesMutationHookResult = ReturnType<typeof useDeleteOrderFulfillmentPicturesMutation>;
export type DeleteOrderFulfillmentPicturesMutationResult = Apollo.MutationResult<DeleteOrderFulfillmentPicturesMutation>;
export type DeleteOrderFulfillmentPicturesMutationOptions = Apollo.BaseMutationOptions<DeleteOrderFulfillmentPicturesMutation, DeleteOrderFulfillmentPicturesMutationVariables>;